/* eslint import/no-cycle: 0 */
import { RouteGenerator } from 'client/util/Constants';
import { addRootClasses } from '@jumpcloud/ui-components';
import { createRouter, createWebHistory } from 'vue-router';
import { useSignupStore } from '../stores/useSignupStore';
import SignupConstants from 'client/util/Constants/SignupConstants';
import dreamdataRouter from 'client/GrowthEngineering/Dreamdata/dreamdataRouter';

const AdminGoogleRegistration = () => import('client/signup/AdminGoogleRegistration/AdminGoogleRegistration.vue');
const AdminSignup = () => import('client/signup/AdminSignup/AdminSignup.vue');
const ConfirmContainer = () => import('client/signup/ConfirmContainer.vue');
const ConfirmPartnerContainer = () => import('client/signup/components/ConfirmPartnerContainer.vue');

const { login } = RouteGenerator;
const { confirmPartnerRouteName } = SignupConstants;

addRootClasses({
  meta: {
    loadLegacyStyles: false,
  },
});

/**
 * This navigation guard prevents routing until all the fields in the step
 * are validated. You can go back from invalid state, but can't go forward.
 * Navigation guards need to be housed in the component that is directly routed to.
 */

export const beforeEnterHelper = (to, from, next) => {
  const signupStore = useSignupStore();
  const { hasLoaded, user } = signupStore;
  const fromStep = from.query.step ? parseInt(from.query.step, 10) : 1;
  const toStep = to.query.step ? parseInt(to.query.step, 10) : 1;

  if (from.name === 'SignupConfirm' && toStep > 1) {
    next({
      name: 'AdminSignup',
      query: {
        step: 1,
      },
    });
  }

  if (hasLoaded) {
    if (user.isValid) {
      signupStore.setValidation(false);
      next();
    } else if (to.path === login) {
      next();
    } else if (toStep < fromStep) {
      signupStore.setValidation(true);
      next();
    } else {
      next(false);
    }
  } else if (toStep !== 1) {
    const goTo = to;
    delete goTo.query.step;
    next(goTo);
  } else {
    next();
  }
};

export const RouterOptions = {
  history: createWebHistory(),
  routes: [
    {
      path: '/signup',
      name: 'AdminSignup',
      component: AdminSignup,
    },
    {
      path: '/signup/confirm',
      name: 'SignupConfirm',
      component: ConfirmContainer,
    },
    {
      path: '/signup/confirm/partner',
      name: confirmPartnerRouteName,
      component: ConfirmPartnerContainer,
    },
    {
      path: '/signup/msp',
      name: 'MspSignup',
      component: AdminSignup,
      beforeEnter: (to, from, next) => {
        const signupStore = useSignupStore();
        signupStore.updateIsMsp(true);
        next();
      },
    },
    {
      path: '/signup/new-org-verification',
      name: 'NewOrgVerification',
      component: AdminGoogleRegistration,
    },
  ],
};

// const router = new VueRouter(RouterOptions);
const router = createRouter(RouterOptions);

router.beforeEach((to, from, next) => beforeEnterHelper(to, from, next));

router.afterEach((to, from, failure) => {
  if (failure) return;

  // SPA page views for Dreamdata (skips the initial load so it does not duplicate the
  // vendor snippet's automatic page() call).
  dreamdataRouter.pageAfterRouteChange(to, from);

  const returnedToSignupForm = (to.name === 'AdminSignup' || to.name === 'MspSignup')
    && (from.name === 'SignupConfirm' || from.name === confirmPartnerRouteName);
  if (returnedToSignupForm) {
    useSignupStore().armFormResetFromConfirm();
  }
});

export default router;
